import { ClientDetailResponse, ClientListResponse, MonitorData, ParametroClientesResponse, ParametrosStatsResponse, SectorsResponse, StatsResponse } from '../types/client';

const BASE = process.env.NODE_ENV === 'production' ? '/api' : '';

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function handleUnauthorized() {
  localStorage.removeItem('token');
  window.location.replace('/login');
}

async function get<T>(path: string): Promise<T> {
  const res = await fetch(`${BASE}${path}`, { headers: authHeaders() });
  if (res.status === 401 && localStorage.getItem('token')) {
    handleUnauthorized();
    throw new Error('Sesión expirada');
  }
  if (!res.ok) throw new Error(`HTTP ${res.status} – ${path}`);
  return res.json();
}

async function post<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    if (res.status === 401 && localStorage.getItem('token')) {
      handleUnauthorized();
      throw new Error('Sesión expirada');
    }
    const err = await res.json().catch(() => ({}));
    throw new Error((err as any).msg ?? `HTTP ${res.status} – ${path}`);
  }
  return res.json();
}

function statsQuery(base: string, sector?: string, subsector?: string): string {
  const params = new URLSearchParams();
  if (sector) params.set('sector', sector);
  if (subsector) params.set('subsector', subsector);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export const api = {
  login: (accessToken: string) => post<{ token: string }>('/users/login', { accessToken }),
  getClients: (query: string) => get<ClientListResponse>(`/clients${query}`),
  getClient: (id: string) => get<ClientDetailResponse>(`/clients/${encodeURIComponent(id)}`),
  getClientMonitor: (id: string) => get<MonitorData>(`/clients/${encodeURIComponent(id)}/monitor`),
  getSectors: () => get<SectorsResponse>('/stats/sectors'),
  getStatsApp: (sector?: string, subsector?: string) => get<StatsResponse>(statsQuery('/stats/app', sector, subsector)),
  getStatsB2b: (sector?: string, subsector?: string) => get<StatsResponse>(statsQuery('/stats/b2b', sector, subsector)),
  getStatsParametros: () => get<ParametrosStatsResponse>('/stats/parametros'),
  getClientesByParametro: (codparametro: string) => get<ParametroClientesResponse>(`/stats/parametros/${encodeURIComponent(codparametro)}`),
};
